import PageSelectProgramme from "../PageProgramme/PageSelectProgramme";

export default function PageDashboardProgramAdmin() {
  return <PageSelectProgramme isDashboard />;
}
